import { render, staticRenderFns } from "./VerticalGroupBarSkills.vue?vue&type=template&id=1ae50803&"
import script from "./VerticalGroupBarSkills.vue?vue&type=script&lang=js&"
export * from "./VerticalGroupBarSkills.vue?vue&type=script&lang=js&"
import style0 from "./VerticalGroupBarSkills.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports